export const INITIAL_STATE = {
  selectedEnvironment: "",
};

export const SET_ENVIRONMENT = "onboarding/SET_ENVIRONMENT";

export const setEnvironment = environment => {
  return {
    type: SET_ENVIRONMENT,
    environment,
  };
};

const environmentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ENVIRONMENT:
      return {
        ...state,
        selectedEnvironment: action.environment,
      };
    default:
      return state;
  }
};

export default environmentReducer;
